import React from 'react';
import { Document, Page,Font, StyleSheet, View, Text,Link,Image } from '@react-pdf/renderer';
import { paginate } from '../../../Transcript/EnrollPDFUtils';
import styles from '../../../Transcript/EnrollPDFStyles';
import LastFooter from '../Schedule/SchedulePDFFooter';
  Font.register({
  family: "NotoSansKR",
  src: "/fonts/NotoSansKR-Regular.ttf",
});
Font.register({
  family: "NotoEthiopic",
  src: "/fonts/NotoSansEthiopic-Regular.ttf",
});
Font.register({
  family: "NotoSans",
  src: "/fonts/NotoSans-Regular.ttf",
});
Font.register({
  family: "NotoSansDevanagari",
  src: "/fonts/NotoSansDevanagari-Regular.ttf",
});
Font.register({
  family: "NotoSansSC",
  src: "/fonts/NotoSansSC-Regular.ttf",
});

Font.register({
  family: "NotoSansArabic",
  src: "/fonts/NotoSansArabic-Regular.ttf",
});
Font.register({
  family: "NotoSansKhmer",
  src: "/fonts/NotoSansKhmer-Regular.ttf",
});
Font.register({
  family: "NotoCombo",
  fonts: [
    { src: "/fonts/NotoSans-Regular.ttf" },
    { src: "/fonts/NotoSansKR-Regular.ttf" },
  ],
});

const detectFont = (text) => {
  // Korean (Hangul)
  if (/[\uAC00-\uD7AF]/.test(text)) return "NotoSansKR";

  // Chinese (Simplified + Traditional)
  if (/[\u4E00-\u9FFF]/.test(text)) return "NotoSansSC";

  // Devanagari (Hindi, Marathi, etc.)
  if (/[\u0900-\u097F]/.test(text)) return "NotoSansDevanagari";

  // Arabic
  if (/[\u0600-\u06FF]/.test(text)) return "NotoSansArabic";

  // Ethiopic (Tigrinya, Amharic)
  if (/[\u1200-\u137F]/.test(text)) return "NotoEthiopic";

  // Khmer
  if (/[\u1780-\u17FF]/.test(text)) return "NotoSansKhmer";

  // Vietnamese (Latin + diacritics)
  if (/[\u0100-\u017F]/.test(text)) return "NotoSans";

  // Basic Latin (English, Somali, etc.)
  if (/[\u0000-\u007F]/.test(text)) return "NotoSans";

  // Default fallback
  return "NotoSans";
};
const EnrollPDFMyDocumentBT30 = ({ enrolledSessionList,result,currentUser,selectBoxValues,onlineSessions }) => (
  <Document>
    <Page size="A4" style={styles.page}>

      {/* Header */}
      

<View style={styles.headerContainer} fixed>
  <Image style={styles.logo} src="/Logo.png" />

  <Text style={styles.header}>
    Enrolled List Report
  </Text>
</View>
{currentUser?.isPowerUser===false ? (<View style={styles.studentInfo}>
  <Text style={styles.studentText}>
    Student Name: {currentUser?.first_name +" " + currentUser?.last_name || "-"}
  </Text>
  <Text style={styles.studentText}>
    Student ID: {currentUser?.username || "-"}
  </Text>
</View>):(<View style={styles.studentInfo}>
  <Text style={styles.studentText}>
     {result?.enrolled?.length > 0 && (
                              <>
                               
                                Caregiver:{" "}
                                {
[...new Set(
  result.enrolled
    .map(e => {
      const user = selectBoxValues.find(u => u.value === e.id_user);
      return user?.label;
    })
)]
  .filter(Boolean)
  .join(", ")
}
                                  {"\n"}
                            </>
                            )}
    
  </Text>
 
</View>)}

<View style={styles.footer} fixed>
 <Text>
    Generated on: {new Date().toLocaleDateString()}
  </Text>

<Text
  render={({ pageNumber, totalPages }) =>
    `Page ${pageNumber} of ${totalPages}`
  }
/>
  
</View>

      {/* Table Header */}  
      <View style={[styles.row,styles.bold]}>
  <Text >
    {"In-Person Courses"}
  </Text>
</View>
<View style={[styles.row]}>
  <Text >
    {"\n"}
  </Text>
</View>
<View style={[styles.row, styles.tableHeader]}>
  <Text style={[styles.headerCell, styles.colDate]}>
    Date
  </Text>
  <Text style={[styles.headerCell, styles.colTime]}>
    Start & End Time
  </Text>
  <Text style={[styles.headerCell, styles.colDuration]}>
    
    {"        "}
  </Text>
  <Text style={[styles.headerCell, styles.colModule]}>
    Module Name
  </Text>
  <Text style={[styles.headerCell, styles.colStatus]}>
    Location
  </Text>
</View>


{enrolledSessionList.map((group, index) => {
        const date = group["0"];
        const sessions = group["1"];

        return (
          <View key={index} style={styles.dateGroup} wrap={false}>
            {sessions.map((entry, i) => 
            {
               if(currentUser?.isPowerUser===false )
              {
               
return (<View key={i} style={styles.row} wrap={false}>

                {/* DATE + TYPE */}
                <View style={[styles.cell, styles.colDate1]}>
                  {i === 0 && <Text style={styles.bold}>{date}</Text>}
                  {/* <Text>
                    {entry.locationType === "onsite"
                      ? "In-Person"
                      : "Webinar"}
                  </Text> */}
                </View>

                {/* TIME */}
                <View style={[styles.cell, styles.colTime1]}>
                  <Text>
                    {entry.startTime} - {entry.endTime}
                  </Text>
                </View>

                {/* DURATION */}
                {/* <View style={[styles.cell, styles.colDuration]}>
                  <Text>{entry.duration}</Text>
                </View> */}

                {/* MODULE */}
                <View style={[styles.cell, styles.colModule,styles.bold]}>
                  <Text
                    lang="de"
                    hyphenationCallback={(word) => [word]}
                  >
                    {entry.module}
                  </Text>
                </View>

                {/* STATUS */}
                <View style={[styles.cell, styles.colStatus1]}>
                  <Text>
                   {entry.locationType==="online" ?(<>Webinar - located in the Caregiver Learning Center.

                   </>):(<>
                   <>
                   {entry.cityLink.name}{"\n"}
                   </>
                   <>
                   {entry.cityLink.address}
                   </>
                   </>)
                   } 

                    
                    
                  </Text>
                </View>

              </View>)
                
              }
              else
              {
const hasMatch = result.enrolled.some(
    (e) =>
      e.id_course === Number(entry.courseId) &&
      selectBoxValues.some((u) => u.value === e.id_user)
  );

  if (hasMatch) {

            return (<View key={i} style={styles.row} wrap={false}>

                {/* DATE + TYPE */}
                <View style={[styles.cell, styles.colDate1]}>
                  {i === 0 && <Text style={styles.bold}>{date}</Text>}
                  {/* <Text>
                    {entry.locationType === "onsite"
                      ? "In-Person"
                      : "Webinar"}
                  </Text> */}
                </View>

                {/* TIME */}
                <View style={[styles.cell, styles.colTime1]}>
                  <Text>
                    {entry.startTime} - {entry.endTime}
                  </Text>
                </View>

                {/* DURATION */}
                {/* <View style={[styles.cell, styles.colDuration]}>
                  <Text>{entry.duration}</Text>
                </View> */}

                {/* MODULE */}
                <View style={[styles.cell, styles.colModule,styles.bold]}>
                  <Text
                    lang="de"
                    hyphenationCallback={(word) => [word]}
                  >
                    {entry.module}
                  </Text>
                </View>

                {/* STATUS */}
                <View style={[styles.cell, styles.colStatus1]}>
                  <Text>
                   {entry.locationType==="online" ?(<>Webinar - located in the Caregiver Learning Center.

                   </>):(<>
                   <>
                   {entry.cityLink.name}{"\n"}
                   </>
                   <>
                   {entry.cityLink.address}
                   </>
                   </>)
                   } 

                    
                    
                  </Text>
                </View>

              </View>);
              }
            }
              
})}
          </View>
        );
      })}

      
<View style={[styles.row]}>
  <Text >
    {"\n"}
  </Text>
</View>
   <View style={[styles.row,styles.bold]}>
  <Text >
    {"Online Courses"}
  </Text>
</View>
<View style={[styles.row]}>
  <Text >
    {"\n"}
  </Text>
</View>
<View style={[styles.row1, styles.tableHeader]}>
  <Text style={[styles.headerCell, styles.hoursCol]}>
    Hours
  </Text>
  <Text style={[styles.headerCell, styles.modeCol]}>
    Mode
  </Text>
  <Text style={[styles.headerCell, styles.courseCol]}>
   Course Name
  </Text>
 
</View>

        {/* Table Body */}
        {onlineSessions
          .sort((a, b) => a.SequenceOrder - b.SequenceOrder)
          .map((session,i) => (
            <View style={styles.row1} key={i}>
              <Text style={[styles.cell, styles.hoursCol1]}>
                {session.Credits}{" "}
                {session.Credits > 1 ? "hours" : "hour"}
              </Text>
              <Text style={[styles.cell, styles.modeCol1]}>Online</Text>
              <Text style={[styles.cell, styles.courseCol1]}>
                {session.CourseName}
              </Text>
            </View>
          ))}
     


{/* 
<View style={[styles.row, styles.tableHeader]}>
  <Text style={[styles.headerCell, styles.colDate]}>
    Online
  </Text>
  <Text style={[styles.headerCell, styles.colTime]}>
    {"        "}
  </Text>
  <Text style={[styles.headerCell, styles.colDuration]}>
    
    {"        "}
  </Text>
  <Text style={[styles.headerCell, styles.colModule]}>
   {"        "}
  </Text>
  <Text style={[styles.headerCell, styles.colStatus]}>
    {"        "}
  </Text>
</View>

{ onlineSessions
                    .sort((a, b) => a.SequenceOrder - b.SequenceOrder)
                    .map((session) => (
                      <div
                        key={session.CourseId}
                        className="bt30-enrolled-enrolled_table_enrolled_row"
                      >
                        <div className="bt30-enrolled-table__hours">
                          {session.Credits}{" "}
                          {session.Credits > 1 ? "hours" : "hour"}
                        </div>
                        <div className="bt30-enrolled-mode">Online</div>
                        <div className="bt30-enrolled-table__course-name">
                          {session.CourseName}
                        </div>
                      </div>
                    ))

                } */}
      
            <View style={{ marginTop: 10 }}>
                <LastFooter></LastFooter></View>
    </Page>
  </Document>
);
export default EnrollPDFMyDocumentBT30;
